import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  class: "card",
  style: {"margin-top":"8px"}
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "梱包後の荷物の重量", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"10px"} }, "重量には商品とそのパッケージを含める必要があります。これは、配送料の計算に使用されます。", -1)
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "荷物の寸法", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"10px"} }, " 荷物の寸法は、配送料の計算に使用されます。入力した寸法と実際の寸法に差がある場合は、その差を補う必要がある場合があります。 ", -1)
const _hoisted_14 = { class: "flex-bwn" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "cm", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "cm", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "cm", -1)
const _hoisted_18 = { class: "form-item" }
const _hoisted_19 = { class: "footer flex-end" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "status" }
const _hoisted_22 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/goods/up_start.png",
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/goods/up_success.png",
  alt: ""
}
const _hoisted_24 = {
  key: 2,
  src: "https://static-s.theckb.com/BusinessMarket/Client/goods/up_loading.png",
  alt: ""
}
const _hoisted_25 = {
  class: "flex-col-1",
  style: {"width":"100%"}
}
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "process" }

import { t } from '@/plugins/i18n'
import { ref, reactive, onMounted } from 'vue'
import { ElDialog, ElPopover, ElMessageBox, ElMessage } from 'element-plus'
import { Warning } from '@element-plus/icons-vue'
import { ttsCategories, ttsCreatProductCheck, ttsPploadImage } from '@/apis/api'
import type { FormInstance } from 'element-plus'
import { publishProduct } from '@/apis/user'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix } from '@/store'
import { extProductRespDTO } from '../data'
import { urlToBlob } from '@/util/useSearchByImage'

export default /*#__PURE__*/_defineComponent({
  props: {
    product: { type: null, required: true }
  },
  emits: ['success'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as {
  product: extProductRespDTO,
}
const processVisiable = ref(false)

const store = useStore()
const router = useRouter()

const upParams = ref<any>({})
const visiable = ref(false)
const formRef = ref<FormInstance>()



const initForm = {
  categoryId: '',
  packageWeight: {
    value: null,
    unit: 'KILOGRAM'
  },
  packageDimensions: {
    height: null,
    length: null,
    width: null,
    unit: 'CENTIMETER'
  },
  imageUrls: {}
}

const formVal = ref(JSON.parse(JSON.stringify(initForm)))

// 新增：校验规则
const rules = {
  'packageDimensions.length': [
    {
      required: true,
      message: '必須項目',
      trigger: 'blur'
    },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value === null || value === '' || isNaN(Number(value))) {
          callback(new Error(t('必须为数字')))
        } else if (Number(value) <= 0) {
          callback(new Error(t('必须大于0')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  'packageDimensions.width': [
    {
      required: true,
      message: '必須項目',
      trigger: 'blur'
    },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value === null || value === '' || isNaN(Number(value))) {
          callback(new Error(t('必须为数字')))
        } else if (Number(value) <= 0) {
          callback(new Error(t('必须大于0')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  'packageDimensions.height': [
    {
      required: true,
      message: '必須項目',
      trigger: 'blur'
    },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value === null || value === '' || isNaN(Number(value))) {
          callback(new Error(t('必须为数字')))
        } else if (Number(value) <= 0) {
          callback(new Error(t('必须大于0')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  'packageWeight.value': [
    {
      required: true,
      message: '必須項目',
      trigger: 'blur'
    },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value === null || value === '' || isNaN(Number(value))) {
          callback(new Error(t('必须为数字'))) // 必须为数字
        } else if (Number(value) <= 0) {
          callback(new Error(t('必须大于0')))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }],
  categoryId: [
    {
      required: true,
      message: '必須項目',
      trigger: 'change'
    }
  ]
}

// tiktok 类目
const categories = ref<any[]>([])
// ElMessageBox.alert(t('上传中...'), t('传输商品信息到店铺'), {
//   showConfirmButton: false,
//   customClass: 'stupid-el',
//   type: 'success'
// }).catch(() => { })

// onMounted(async () => {
//   const res = await ttsCategories()

// })

const uploadProgress = ref(0)
const upShopPic = async () => {
  processVisiable.value = true
  uploadProgress.value = 0
  const { productMainImg, productItemImgs = [], productDescImgs = [], skuList = [] } = props.product
  const list = [
    {
      type: 'MAIN_IMAGE',
      url: productMainImg
    },
    ...productItemImgs.map((item: any) => {
      return {
        type: 'MAIN_IMAGE',
        url: item.url
      }
    }),
    ...productDescImgs.map((item: any) => {
      return {
        type: 'DESCRIPTION_IMAGE',
        url: item
      }
    }),
    ...skuList.map((item: any) => {
      return {
        type: 'ATTRIBUTE_IMAGE',
        url: item.productSkuImg
      }
    })
  ].filter((item: any) => {
    return item.url
  })
  let index = 0
  for (const img of list) {
    let blob = null
    try {
      blob = await urlToBlob(img.url)
      if (blob) {
        // 处理 Blob（如创建 File 对象、生成预览等）
        const file = new File([blob], 'image.jpg', { type: blob.type });
        const formData = new FormData()
        formData.append('file', file)
        formData.append('useCase', img.type)
        const { data } = await ttsPploadImage(formData)
        formVal.value.imageUrls[img.url + img.type] = data
      }
    } catch (error) {
      if (img.type !== 'DESCRIPTION_IMAGE') {
        throw new Error('图片转换失败')
      }
    }
    index++
    uploadProgress.value = Math.ceil((index / list.length) * 100)
  }
}

const runUpGoods = async () => {
  try {
    await upShopPic()
    await publishProduct({ ...upParams.value, ...formVal.value, categoryId: [...formVal.value.categoryId].pop() } as any).then(
      (res) => {
        if (res.success) {
          emits('success')
          ElMessageBox.alert(
            t('创建成功，并已为您自动创建关联'),
            t('传输商品信息到店铺'),
            {
              confirmButtonText: t('查看关联商品库'),
              type: 'success',
              closeOnClickModal: true
            }
          )
            .then(() => {
              router.push(useRtfix('AssociatedProductlib'))
            })
            .catch(() => { })
        }
      }
    ).finally(() => {
      processVisiable.value = false
    })
  } catch (error) {
  ElMessage.error('製品のアップロードに失敗しました')
  processVisiable.value = false
  }
}

const upTiktokShop = async () => {
  console.log('我执行了')
  await formRef.value?.validate(async (valid: any, fields: any) => {
    if (valid) {
      console.log(formVal, 'formVal');
      runUpGoods()
      visiable.value = false
    } else {
      console.log('error submit!', fields)
    }
  })
}

const processCategories = (categories: any[]): any[] => {
  return categories.map(cat => {
    const disabled = !(cat.permissionStatuses && cat.permissionStatuses.includes('AVAILABLE'))
    const children = cat.ttscategoryResp && cat.ttscategoryResp.length > 0
      ? processCategories(cat.ttscategoryResp)
      : []
    return {
      ...cat,
      disabled,
      ttscategoryResp: children
    }
  })
}

expose({
  show: async (data: any) => {
    upParams.value = data
    const res = await ttsCategories()
    categories.value = processCategories(res.data)
    visiable.value = true
    formRef.value?.resetFields()
    formVal.value = JSON.parse(JSON.stringify(initForm))
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElSpace = _resolveComponent("ElSpace")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElDialog), {
      "custom-class": "tiktokDialog",
      "append-to-body": "",
      modelValue: visiable.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((visiable).value = $event)),
      width: "640px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('上传商品信息')), 1),
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          model: formVal.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('类目')), 1),
              _createVNode(_component_el_form_item, { prop: "categoryId" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_cascader, {
                    props: { label: 'localName', value: 'id', children: 'ttscategoryResp' },
                    modelValue: formVal.value.categoryId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formVal.value.categoryId) = $event)),
                    class: "cascader",
                    options: categories.value,
                    placeholder: _unref(t)('请选择')
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('配送')), 1),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_unref(ElPopover), {
                  width: 200,
                  trigger: "hover",
                  placement: "bottom"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"color":"rgba(0, 0, 0, .45)","margin-left":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, { prop: "packageWeight.value" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    maxlength: 6,
                    modelValue: formVal.value.packageWeight.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formVal.value.packageWeight.value) = $event)),
                    style: {"max-width":"300px","margin-top":"8px"},
                    class: "input-with-select"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formVal.value.packageWeight.unit,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formVal.value.packageWeight.unit) = $event)),
                        style: {"width":"150px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "グラム(g)",
                            value: "GRAM"
                          }),
                          _createVNode(_component_el_option, {
                            label: "キログラム（kg）",
                            value: "KILOGRAM"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_unref(ElPopover), {
                  width: 200,
                  trigger: "hover",
                  placement: "bottom"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"color":"rgba(0, 0, 0, .45)","margin-left":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_form_item, { prop: "packageDimensions.height" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      maxlength: 6,
                      modelValue: formVal.value.packageDimensions.height,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formVal.value.packageDimensions.height) = $event)),
                      style: {"width":"181px"},
                      placeholder: "高さ"
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "packageDimensions.width" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      maxlength: 6,
                      modelValue: formVal.value.packageDimensions.width,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formVal.value.packageDimensions.width) = $event)),
                      style: {"width":"181px"},
                      placeholder: "幅"
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "packageDimensions.length" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      maxlength: 6,
                      modelValue: formVal.value.packageDimensions.length,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formVal.value.packageDimensions.length) = $event)),
                      style: {"width":"181px"},
                      placeholder: "長さ"
                    }, {
                      suffix: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_alert, {
                  style: {"margin-top":"8px"},
                  title: "※重量・体積データは、TikTok側で送料の推定に使用される項目です。出荷時点で正確な値が不明な場合は、おおよその数値を入力してください。あとからTikTokセラーセンターで修正可能です。",
                  type: "info",
                  "show-icon": ""
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_ElSpace, null, {
            default: _withCtx(() => [
              _createVNode(_component_ElButton, {
                round: "",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (visiable.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ElButton, {
                onClick: upTiktokShop,
                round: "",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      width: "400px",
      "custom-class": "uploadDialog",
      "append-to-body": "",
      modelValue: processVisiable.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((processVisiable).value = $event)),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (uploadProgress.value === 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_22))
              : (uploadProgress.value === 100)
                ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                : (_openBlock(), _createElementBlock("img", _hoisted_24))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (uploadProgress.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(t)('等待上传中，请稍候...')), 1))
                : (uploadProgress.value === 100)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(t)('已完成上传，感谢你的耐心等待！')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(t)('正在上传中，请稍候...')), 1))
            ]),
            _createVNode(_component_el_progress, {
              class: "mt-[8px]",
              percentage: uploadProgress.value,
              "stroke-width": 8,
              status: uploadProgress.value === 100 ? 'success' : '',
              "show-text": false
            }, null, 8, ["percentage", "status"]),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('已上传{x}%', { x: uploadProgress.value })), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})